<script context="module">
  // for passing focus on to the next Modal in the queue.
  // A module context level object is shared among all its component instances. [Read More Here](https://svelte.dev/tutorial/sharing-code)
  const modalList = [];
</script>

<script>
  import { fade, fly } from "svelte/transition";
  import { writable } from "svelte/store";

  export function booleanStore(initial) {
    const isOpen = writable(initial);
    const { set, update } = isOpen;
    return {
      isOpen,
      open: () => set(true),
      close: () => set(false),
      toggle: () => update((n) => !n),
    };
  }
  const store = booleanStore(false);
  const { isOpen, open, close } = store;
  export let backdropClose;
  export let size;
  let sizeclass;
  if (size) {
    sizeclass = size;
  } else {
    sizeclass = "xs";
  }
  function closeif() {
    if (backdropClose) {
      close();
    }
  }
  function keydown(e) {
    e.stopPropagation();
    if (e.key === "Escape") {
      close();
    }
  }
  function transitionend(e) {
    const node = e.target;
    node.focus();
  }
  function modalAction(node) {
    const returnFn = [];
    // for accessibility
    if (document.body.style.overflow !== "hidden") {
      const original = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      returnFn.push(() => {
        document.body.style.overflow = original;
      });
    }
    node.addEventListener("keydown", keydown);
    node.addEventListener("transitionend", transitionend);
    node.focus();
    modalList.push(node);
    returnFn.push(() => {
      node.removeEventListener("keydown", keydown);
      node.removeEventListener("transitionend", transitionend);
      modalList.pop();
      // Optional chaining to guard against empty array.
      //  modalList[modalList.length - 1]?.focus();
    });
    return {
      destroy: () => returnFn.forEach((fn) => fn()),
    };
  }
</script>

<slot name="trigger" {open}>
  <!-- fallback trigger to open the modal -->
  <button on:click={open}>Open</button>
</slot>
{#if $isOpen}
  <div
    transition:fade={{ duration: 300 }}
    class="fixed top-0 left-0 z-20 flex items-center justify-center w-full h-screen modal"
    use:modalAction
    tabindex="0"
  >
    <div
      class="absolute w-screen h-screen bg-black bg-opacity-50 backdrop"
      on:click={closeif}
    />

    <div
      transition:fly={{ y: 200, duration: 300 }}
      class="shadow-xl bg-white z-10 rounded-lg p-5 overflow-hidden relative {sizeclass}"
      style="height: calc(100% - 80px); min-height: 150px; margin-top: 70px;"
    >
      <div class="pb-3">
        <slot name="header" {store}>
          <!-- fallback -->
          <div>
            <h1>Your Modal Heading Goes Here...</h1>
          </div>
        </slot>
      </div>
      <div class="overflow-y-auto content" style="height: calc(100% - 95px);">
        <slot name="content" {store} />
      </div>

      <slot name="footer" {store}>
        <!-- fallback -->
        <div>
          <div class="separate" />
          <button
            type="button"
            on:click|preventDefault={close}
            class="float-right px-4 py-1 mx-1 mt-6 text-red-200 bg-red-600 rounded-lg shadow-md cursor-pointer active:bg-gray-500 focus:outline-none hover:shadow"
            >close</button
          >
        </div>
      </slot>
    </div>
  </div>
{/if}
